export default "__VITE_ASSET__6dcb3fb0__"